import axios, { AxiosResponse } from "axios";
// import { showToastMessage } from "../common/service/CommonService";
import { Navigate } from "react-router-dom";
import * as Url from "./url_helper";
import { idealTimeout } from "../Routes";
import { clearLocalStorage, showToastMessage, userLogout } from "common/service/CommonService";
import { AUTH_PATHS } from "Routes/paths";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
      delete axios.defaults.headers.common["Authorization"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// intercepting to capture errors
let isLoggingOut = false;

axios.interceptors.response.use(
  (response) => {
    return response.data ? response.data : response;
  },
  (error) => {
    if (error.response?.status === 401) {
      if (!isLoggingOut) {
        isLoggingOut = true;
        clearLocalStorage();
        if (window.location.pathname !== AUTH_PATHS.UNAUTHORIZED) {
          window.location.href = AUTH_PATHS.UNAUTHORIZED;
        }
      }
      return Promise.reject("Unauthorized");
    }

    if (
      error.response &&
      (error.response.data?.statusCode === 400 ||
        error.response.data?.statusCode === 409 ||
        error.response.data?.statusCode === 422 ||
        error.response?.status === 422)
    ) {
      return Promise.reject(
        error.response.data?.message ||
          "The uploaded report does not match the screening subject's details."
      );
    }

    let message = "Something went wrong";

    switch (error.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 404:
        message = "Sorry! The data you are looking for could not be found.";
        break;
      case 422:
        message =
          error.response.data?.message ||
          "The uploaded report does not match the screening subject's details.";
        break;
      default:
        message = error.message || message;
    }

    return Promise.reject(message);
  }
);

/**
 * Sets the default authorization
 */
const setAuthorization = (token: string): void => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */
  get = async (url: string, params?: Record<string, any>): Promise<any> => {
    // const isTokenValid: boolean = await checkValidToken();

    // if (!isTokenValid) {
    //   window.location.href = "/login";
    //   return;
    // }

    return axios.get(url, { params });
  };

  /**
   * Post given data to url
   */
  // create = async (
  //   url: string,
  //   data: Record<string, any>
  // ): Promise<any> => {
  //   data.database =  process.env.REACT_APP_DATABASE as string;
  //   checkValidToken();
  //   return await axios.post(url, data);
  // };

  create = async (
    url: string,
    data: Record<string, any> | FormData,
    config?: any,
  ): Promise<any> => {
    if (data instanceof FormData) {
      data.append("database", process.env.REACT_APP_DATABASE as string);
      data.append("compid", String(getLoggedinUser()?.compid));
      data.append("branid", String(getLoggedinUser()?.branid));
    }
    else if (data.databaseType == "talent") {
      delete data.databaseType;
      data.CompId = getLoggedinUser()?.compid;
      data.BranId = getLoggedinUser()?.branid;
    }
    else {
      data.database = process.env.REACT_APP_DATABASE as string;
      data.compid = getLoggedinUser()?.compid;
      data.branid = getLoggedinUser()?.branid;
    }
    return await axios.post(url, data, config);
  };

  /**
   * Updates data
   */
  update = (url: string, data: Record<string, any>): Promise<any> => {
    return axios.patch(url, data);
  };

  put = (url: string, data: Record<string, any>): Promise<any> => {
    return axios.put(url, data);
  };

  /**
   * Delete
   */


}

const getLoggedinUser = (): any | null => {
  const user = localStorage.getItem("currentUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

let lastTokenCheckTime: number | null = null;

// Validate if user token is still valid
const checkValidToken = async (): Promise<boolean> => {
  const currentUser = localStorage.getItem("currentUser");
  const token = localStorage.getItem("token");
  const database = process.env.REACT_APP_DATABASE as string;

  if (!currentUser || !token) return false;

  if (!sessionStorage.getItem("IsIdealTimeOut")) {
    sessionStorage.setItem("IsIdealTimeOut", "0");
    return false;
  }

  const now = Date.now();

  if (!lastTokenCheckTime || now - lastTokenCheckTime > idealTimeout) {
    const userId: number = JSON.parse(currentUser).userid;
    const isValid = await validateToken(userId, token, database);

    if (!isValid) return false;

    lastTokenCheckTime = now;
  }

  return true;
};

const validateToken = async (
  UserId: number,
  Token: string,
  Database: string,
): Promise<any> => {
  try {
    const response = await axios.get(
      Url.Admin_API.AUTH_API +
        "ValidToken?userid=" +
        UserId +
        "&token=" +
        Token +
        "&database=" +
        Database,
    );


    if (!response.data) {
      localStorage.removeItem("toast");
      localStorage.removeItem("token");
      localStorage.removeItem("currentPage");
      localStorage.removeItem("currentUser");
      return <Navigate to={{ pathname: "/login" }} />;
    } else return true;
  } catch (error) {
    return <Navigate to={{ pathname: "/login" }} />;
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
